<template>
  <div class="crumb">
    <i :class="pageIcon"></i>&nbsp;
    <span v-if="$route && $route.params && $route.params.province_id">{{Provinces[$route.params.province_id].province_name}} \ </span>
    <span v-if="$route && $route.params && $route.params.club_id">{{Clubs[$route.params.club_id].club_number + ' ' + Clubs[$route.params.club_id].club_name }} \ </span>
    {{label}}
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    components: {
    },
    data () {
      return {
        list: null
      }
    },
    created () {
    },
    computed: {
      ...mapGetters('security', ['Provinces', 'Clubs']),
      pageIcon () {
        if (this.$route.meta && this.$route.meta.icon) {
          return 'mdi ' + this.$route.meta.icon
        } else {
          return null
        }
      },
      label () {
        if (this.$route.meta.label) {
          return this.$route.meta.label
        }
        return this.$route.name
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  @import '../../assets/colors.scss';

  .crumb {
    padding: 0px 10px 10px 0px;
    color: $lynxGreenMedium;
    font-size:1.3rem
  }
</style>



// WEBPACK FOOTER //
// Levelbar.vue?d4168f06